import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { getHomeData } from '../../services/Home/HomeService';
import { MenuItem } from '../../interfaces/Home/MenuItem';

interface HomeContextType {
  menu: MenuItem[];
  atalhos: MenuItem[];
  setAtalhos: React.Dispatch<React.SetStateAction<MenuItem[]>>;
  loading: boolean;
  error: string | null;
}

const HomeContext = createContext<HomeContextType | undefined>(undefined);

export const useHomeContext = () => {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error('useHomeContext must be used within a HomeProvider');
  }
  return context;
};

export const HomeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [menu, setMenu] = useState<MenuItem[]>([]);
  const [atalhos, setAtalhos] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { menu, atalhos } = await getHomeData();
        setMenu(menu);
        setAtalhos(atalhos);
      } catch (err: any) {
        setError('Erro ao carregar os dados');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <HomeContext.Provider value={{ menu, setAtalhos, atalhos, loading, error }}>
      {children}
    </HomeContext.Provider>
  );
};
